// generated from 85_586 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xCustomEventInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_custom_event_in_y_days"),
  // undefined: 85_557 (99.97%), defined 29 (0.03%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "3", // 53_593 (62.62%)
    "1", // 27_651 (32.31%)
    "5", // 4_342 (5.07%)
  ]),
  display_name: z.string(),
  // undefined: 17_697 (20.68%), defined 67_889 (79.32%)
  raw_value: z
    .object({
      // avg: 6.43, min: 1, max: 30
      num_days: z.int().min(1).max(30),
      // avg: 0.29, min: 0, max: 50
      num_occurrences: z.int().min(0),
    })
    .optional(),
  value: z.object({
    // avg: 7.21, min: 1, max: 30
    num_days: z.int().min(1).max(30),
    // avg: 0.39, min: 0, max: 1000
    num_occurrences: z.int().min(0),
  }),
  varies_by_app_group: z.literal(true),
});
